var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSliderArrows = function SvgSliderArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 51,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3B58E3",
    fillRule: "evenodd",
    d: "M13.567 9.78a1.56 1.56 0 0 1 2.202.17l12.5 14.584a1.56 1.56 0 0 1 0 2.034l-12.5 14.583a1.563 1.563 0 0 1-2.371-2.034l11.627-13.566-11.627-13.567a1.56 1.56 0 0 1 .167-2.202zm8.333 0a1.56 1.56 0 0 1 2.204.17l12.5 14.584a1.56 1.56 0 0 1 0 2.034l-12.5 14.583a1.563 1.563 0 1 1-2.375-2.034L33.36 25.551 21.733 11.984a1.56 1.56 0 0 1 .17-2.202z",
    clipRule: "evenodd"
  })));
};
export default SvgSliderArrows;